(() => {
  const policy = document.querySelector('.shopify-policy__container');
  const body = policy?.querySelector('.shopify-policy__body');
  if (body && !policy.querySelector('.sy-legal-layout')) {
    const headings = [...body.querySelectorAll('h2,h3')];
    if (headings.length > 2) {
      const layout = document.createElement('div'); layout.className = 'sy-legal-layout';
      const toc = document.createElement('nav'); toc.className = 'sy-legal-toc'; toc.setAttribute('aria-label', 'On this page');
      const title = document.createElement('strong'); title.textContent = 'On this page'; toc.append(title);
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `policy-section-${index + 1}`;
        const link = document.createElement('a'); link.href = `#${heading.id}`; link.textContent = heading.textContent.trim(); toc.append(link);
      });
      body.before(layout); layout.append(body, toc);
    }
  }
  const search = document.querySelector('[data-sy-search-page]');
  const topics = search?.querySelector('[data-search-topics]');
  const query = search?.querySelector('input[name="q"]')?.value.trim();
  if (topics && query) {
    const url = new URL(`${search.dataset.searchRoute}/suggest.json`, location.origin);
    url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'collection,page'); url.searchParams.set('resources[limit]', '8');
    fetch(url).then(response => { if (!response.ok) throw new Error('Suggestions unavailable'); return response.json(); }).then(data => {
      const worlds = (data.resources?.results?.pages || []).filter(item => /\/pages\/(money-business|creator-marketing|ai-technology|mindset-communication|life-health-confidence)(\?|$)/.test(item.url));
      const collections = (data.resources?.results?.collections || []).filter(item => item.url && !['membership', 'suityou-other-products-needs-review'].includes(new URL(item.url, location.origin).pathname.split('/').filter(Boolean).pop()));
      const items = [...worlds, ...collections];
      items.filter(item => item.url && item.title).forEach(item => { const link = document.createElement('a'); link.href = item.url; link.textContent = item.title; topics.append(link); });
      topics.hidden = !topics.childElementCount;
    }).catch(() => { /* Native results remain available if suggestions fail. */ });
  }
})();
